import { useField } from 'vee-validate';
import Select from '../../ui/Select.vue';


export default {
  __name: 'SelectedCallDate',
  setup(__props, { expose }) {
  expose();

const { value, setValue, errorMessage } = useField('selectedCallDate');

const {
    value: dayValue,
    setValue: setDayValue,
    errorMessage: dayErrorMessage,
} = useField('selectedDayDate');

const options = [
    {
        id: '9:00-12:00',
        title: '9:00-12:00',
    },
    {
        id: '12:00-15:00',
        title: '12:00-15:00',
    },
    {
        id: '15:00-18:00',
        title: '15:00-18:00',
    },
    {
        id: '18:00-21:00',
        title: '18:00-21:00',
    },
];

const dateOptions = [
    { id: 'Dzisiaj', title: 'Dzisiaj' },
    { id: 'Jutro', title: 'Jutro' },
];

const __returned__ = { value, setValue, errorMessage, dayValue, setDayValue, dayErrorMessage, options, dateOptions, get useField() { return useField }, Select }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}